import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchShortUrl } from '../apis/short-url';

function ShortUrlRedirectPage() {
  const { code } = useParams();

  useEffect(() => {
    const fetchAndRedirect = async (code: string) => {
      try {
        const shortUrl = await fetchShortUrl(code);

        const { originHost, originPath } = shortUrl;
        const targetUrl = `${originHost}${originPath}`;
        window.location.href = targetUrl;
      } catch (err) {
        console.error('Redirection failed:', err);
        // 실패 시 fallback 페이지로 이동하거나 오류 표시
        window.location.href = '/';
      }
    };

    if (code) fetchAndRedirect(code);
    else {
      window.location.href = '/';
    }
  }, [code]);

  return <div />;
}

export default ShortUrlRedirectPage;
